export const UI_6_1_tableRow = [
  [
    {
      cellName: "번호",
      id: "transNo",
      row: 1,
      col: 1,
      style: { width: "4%" },
    },
    {
      cellName: "에너지종류",
      id: "energy",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "산단명",
      id: "complexName",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
     {
      cellName: "SOURCE 공장",
      id: "sourcePlant",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "SINK 공장",
      id: "sinkPlant",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
   
    {
      cellName: "거래체결일",
      id: "transDate",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "거래기간",
      id: "transPeriod",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "월계약거래량",
      id: "monthCntrtTrnsVol",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "시간당최대계약거래량",
      id: "hourlyMaxCntrtTrnsVol",
      row: 1,
      col: 1,
      style: { width: "9%" },
    },
    {
      cellName: "거래상태",
      id: "trnsStCd",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "거래방식",
      id: "trnsMethdCd",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "거래단가",
      id: "trnsChrg",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
    {
      cellName: "거래설명",
      id: "trnsDescr",
      row: 1,
      col: 1,
      style: { width: "8%" },
    },
  ]
]